<script setup lang="ts">
import { computed } from 'vue';
import { PlanFilter } from '@/application/smallBusiness/domain/SmallBusinessPlanFilters';
import CalChoiceToggle from '@/application/smallBusiness/infrastructure/components/CalChoiceToggle.vue';

interface EmitInterface {
  (event: 'update-values', value: Array<PlanFilter>): void
  (event: 'update-cal-choice'): void
}

const emits = defineEmits<EmitInterface>();

const props = withDefaults(defineProps<{
  filters: Array<PlanFilter>;
  sizeWidth?: string;
  loading?: boolean;
}>(), {
  sizeWidth: 'max-w-xs',
});

const localFilters = computed(() => props.filters.map(filter => ({
  ...filter,
  options: filter.options.map(option => ({ ...option }))
})) as Array<PlanFilter>);

const emitChanges = (): void => {
  emits('update-values', localFilters.value);
};

const emitChangesCalChoice = (): void => {
  emits('update-cal-choice');
};
</script>
<template>
  <div v-if="loading" class="space-y-4">
    <div class="animate-pulse flex flex-col space-y-4">
      <div v-for="index in 3" :key="index" class="flex-1 space-y-6 py-1">
        <div class="h-2 bg-slate-300 rounded w-32"></div>
        <div class="space-y-3">
          <div class="flex flex-row">
            <div class="h-2 bg-slate-300 rounded w-6"></div>
            <div class="h-2 ml-2 bg-slate-300 rounded w-full"></div>
          </div>
        </div>
        <div class="space-y-3">
          <div class="flex flex-row">
            <div class="h-2 bg-slate-300 rounded w-6"></div>
            <div class="h-2 ml-2 bg-slate-300 rounded w-full"></div>
          </div>
        </div>
        <div class="space-y-3">
          <div class="flex flex-row">
            <div class="h-2 bg-slate-300 rounded w-6"></div>
            <div class="h-2 ml-2 bg-slate-300 rounded w-full"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="filters.length > 0" class="flex flex-col w-full space-y-4" :class="sizeWidth">
    <div v-for="filter in localFilters" :key="filter.name" class="flex flex-col" :class="sizeWidth">
      <div class="flex mb-1 font-semibold text-gray-700">
        {{ filter.name }}
      </div>
      <div v-for="option in filter.options" :key="option.key" class="flex w-full items-center space-x-2">
        <div>
          <input type="checkbox" class="flex border-gray-300 rounded-md w-4 h-4 cursor-pointer" v-model="option.value" :id="`checkbox-${filter.name}-${option.key}`" @change="emitChanges" />
        </div>
        <label class="cursor-pointer" :for="`checkbox-${filter.name}-${option.key}`">{{ option.text }} <span v-if="option.amount && option.amount > 0">({{ option.amount }})</span></label>
      </div>
    </div>
    <CalChoiceToggle class="mt-4 sm:mt-0 mb-4" size="sm" on-label-class="text-sm" @change="emitChangesCalChoice" />
  </div>
</template>
